import { Box, Center, Icon, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FaTools } from "react-icons/fa";
import { StepNavigation } from "../../../../../common/StepNavigation";

interface Props {
  title: string;
  previousStep?: () => void;
}

export const ComingStep = ({ title, previousStep }: Props) => {
  const { t } = useTranslation();
  return (
    <Box pb="8" pt="10">
      <Center borderWidth="1px" borderRadius="lg" py="16" mb="8" flexDirection="column" gap="3">
        <Icon as={FaTools} boxSize="6" color="smMuted" />
        <Stack spacing="1" textAlign="center">
          <Text fontWeight="semibold">{title}</Text>
          <Text fontSize="sm" color="smMuted">
            {t("This step is coming soon.")}
          </Text>
        </Stack>
      </Center>
      <StepNavigation onPrevious={previousStep} />
    </Box>
  );
};
